import { Injector } from "@angular/core";
import { BaseNode } from "../../BaseNode";
import { QPPVEntity } from "../../../Data/MedicinalProductData/QPPVEntity";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { environment } from "../../../../../../environments/environment";



export class TreeNodeMedicinalProductsQPPV extends BaseNode{

    constructor(injector: Injector, labelTemplate: string, parent: BaseNode, model: any) {
        super(injector, new QPPVEntity(injector,model), labelTemplate);
        this.parent=parent;
        this.ioc!.get(Art57Section).generateNumColumValue(this);
    }

    override cloneNode(newParent: BaseNode): BaseNode {
      let clonedNode: TreeNodeMedicinalProductsQPPV = new TreeNodeMedicinalProductsQPPV(this.ioc!, this.label!, newParent, this.data.model.id);      

      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

// property doesn't exist      clonedNode.cloningNode = false;
      return clonedNode;

    }


}